var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clock"},[_c('p',[_c('span',{attrs:{"id":"clock"}},[_vm._v(_vm._s(_vm.koko))]),_vm._v(" "),_c('fa-icon',{attrs:{"icon":['fas', 'clock']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }